var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showSimilarProducts)?_c('div',{staticClass:"similar-products"},[_c('h2',[_vm._v("Similar Products")]),_c('div',{staticClass:"products-container"},_vm._l((_vm.similarProducts),function(product){return _c('product',{key:product.id,attrs:{"product":product}})}),1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }